class NfeDashboardNumeracaoModal {
    static get $inject() {
        return ['gql', '$scope', 'Empresas', '$uibModal']
    }

    constructor(gql, $scope, Empresas, modal) {
        this.apply = fn => $scope.$apply(fn)
        this.gql = gql
        this.Empresas = Empresas
        this.filter = {}
        this.perPage = 20
        this.currentPage = 1
        this.countTotal = 0
        this.countNfe = 0
        this.countNfce = 0
        this.modal = modal
        this.intervalosAusentes = []

        $scope.$watch(() => this.filial, () => {
            if (this.filial) {
                this.promise = this
                    .listIntervalosNumeracaoAusentesCounts(this.filial.id)
                    .then(countIntervalos => {
                        this.countTotal = countIntervalos.sum("count")
                        this.countNfe = countIntervalos.filter(i => i.modelo === "NFE").sum("count")
                        this.countNfce = countIntervalos.filter(i => i.modelo === "NFCE").sum("count")

                        this.countIntervalosNumeracaoAusentes = countIntervalos.groupBy(c => c.modelo)
                    })
                    .finally(() => this.apply())
            }
        }, true)
    }

    $onInit() {
        let today = new Date()

        this.filterPeriodo = {
            periodo: {
                inicial: new Date(today.getFullYear(), today.getMonth(), 1),
                final: today
            }
        }

        this.promise = this.Empresas
            .listFiliais(this.resolve.empresaId)
            .then(filiais => this.filiais = filiais)
            .finally(() => this.apply())
    }

    listIntervalosNumeracaoAusentesCounts(filialId) {
        const query = gql`
            query ListIntervalosNumeracaoAusentesCounts($filialId: Int!) {
                filial(id: $filialId) {
                    id
                    countIntervalosNumeracaoAusentes {
                        modelo
                        serie
                        count
                        ultimaNumeracao
                    }
                }
            }
        `

        return this.gql
            .query(query, { filialId: parseInt(filialId) })
            .then(({ filial: { countIntervalosNumeracaoAusentes } }) => countIntervalosNumeracaoAusentes)
    }

    listIntervalosNumeracaoPresentes(intervalosNumeracao) {
        const { intervalos } = intervalosNumeracao
            .sortBy(i => i.intervalo.from)
            .reduce(({ anterior, intervalos }, intervalo) => {
                const intervaloAtual = { from: anterior.to + 1, to: intervalo.intervalo.from - 1 }

                if (intervaloAtual.from <= intervaloAtual.to) {
                    intervalos.push({
                        ...intervalo,
                        intervalo: intervaloAtual,
                        presente: true
                    })
                }
                return { anterior: intervalo.intervalo, intervalos }
            }, { anterior: { from: null, to: 0 }, intervalos: [] })

        return intervalos
    }

    selectSerie(serie) {
        this.intervalosNumeracao = []
        this.intervalosAusentes = []
        this.onlyPresentes = false
        this.onlyAusentes = false
        this.serie = serie

        this.promise = this.search(
            {
                filial: this.filial,
                modelo: this.filter.modelo,
                serie: serie,
                periodoIncludes: {
                    from: this.formatDate(this.filterPeriodo?.periodo?.inicial),
                    to: this.formatDate(this.filterPeriodo?.periodo?.final)
                }
            }
        )
    }

    get countIntervalosNumeracaoAusentesOfModelo() {
        if (this.filter.modelo) {
            return this.countIntervalosNumeracaoAusentes[this.filter.modelo]
        }
        return []
    }

    loadMore(page) {
        return this.search(
            {
                filial: this.filial,
                modelo: this.filter.modelo,
                serie: this.serie,
                periodoIncludes: {
                    from: this.filterPeriodo ? this.formatDate(this.filterPeriodo.periodo.inicial) : null,
                    to: this.filterPeriodo ? this.formatDate(this.filterPeriodo.periodo.final) : null
                }
            }, page)
    }

    search(filter, page = {}) {
        const { filial, ...params } = filter

        this.loadingPromise = this.listIntervaloNumeracao(filial.id, params, { ...page, size: this.perPage, order: this.order })
            .then(({ intervalosNumeracao, after }) => {
                if (page.after) {
                    this.currentPage = this.currentPage + 1
                }

                this.intervalosAusentes = [...this.intervalosAusentes, ...intervalosNumeracao]

                const intervalosNumeracaoPresentes = this.listIntervalosNumeracaoPresentes(this.intervalosAusentes)

                this.intervalosNumeracao = [...intervalosNumeracaoPresentes, ...this.intervalosAusentes]
                    .sortBy(i => i.intervalo.from)
                    .filter(i => i.intervalo.to != null)

                this.nextPage = after
            })
            .catch(console.error)
            .finally(() => this.apply())
    }

    updateFilter() {
        if (this.filterPeriodo) {
            let from = this.filterPeriodo.periodo?.inicial
            let to = this.filterPeriodo.periodo?.final

            this.filter.periodoIncludes = { from: from, to: to }
        }

        delete this.filter.periodo

        this.filter = Object.assign(this.filter, { filial: this.filial })

        if (this.serie)
            this.selectSerie(this.serie)
    }

    formatDate(date) {
        if (date) {
            let day = date.getDate().toString().padLeft(2, '0')
            let month = (date.getMonth() + 1).toString().padLeft(2, '0')
            let year = date.getFullYear()

            return `${year}-${month}-${day}`
        } else {
            return null
        }
    }

    downloadXlsx() {
        this.modal.open({
            backdrop: 'static',
            component: 'intervaloNumeracaoReportModal',
            size: 'lg',
            resolve: {
                filter: () => this.filter,
                filial: () => this.filial,
                serie: () => this.serie
            }
        })
    }

    listIntervaloNumeracao(filialId, filter, args = {}) {
        const query = gql`
            query($filialId: Int!, $size: Int, $order: IntervaloNumeracaoOrder, $before: String, $after: String, $filter: IntervaloNumeracaoFilter!) {
                filial(id: $filialId) {
                    id
                    intervalosNumeracaoPage(size: $size, order: $order, before: $before, after: $after, filter: $filter) {
                        after
                        before
                        intervalos: entries {
                            ... on IntervaloNumeracaoAusente {
                                id
                                intervalo {from, to}
                                modelo
                                serie
                            }
                        }
                    }
                }
            }
        `

        return this.gql
            .query(query, { filialId: parseInt(filialId), filter, ...args })
            .then(({ filial: { intervalosNumeracaoPage } }) => {
                return {
                    intervalosNumeracao: intervalosNumeracaoPage.intervalos,
                    before: intervalosNumeracaoPage.before,
                    after: intervalosNumeracaoPage.after
                }
            })
    }

    selectOnlyAusentes() {
        this.onlyPresentes = false
        this.onlyAusentes = !this.onlyAusentes
    }

    selectOnlyPresentes() {
        this.onlyAusentes = false
        this.onlyPresentes = !this.onlyPresentes
    }

    get numeracoes() {
        if (this.onlyAusentes) return this.intervalosNumeracao.reject(i => i.presente)
        if (this.onlyPresentes) return this.intervalosNumeracao.filter(i => i.presente)
        return this.intervalosNumeracao
    }
}

angular.module('eficienciaFiscalModule')
    .component('nfeDashboardNumeracaoModal', {
        controller: NfeDashboardNumeracaoModal,
        bindings: {
            close: '&',
            resolve: '<'
        },
        template: `
            <modal modal-title="Numerações de Notas Fiscais no Eficiência Fiscal" close="$ctrl.close">
                <modal-body>                   
                        <loading promise="$ctrl.promise">
                            <div class="form-group col-sm-12">
                                <label>Filial</label>
                                <ef-filial-selector
                                    empresas="$ctrl.filiais"
                                    empresa-id="$ctrl.resolve.empresaId"
                                    name="filial"
                                    ng-model="$ctrl.filial">
                                </ef-filial-selector>
                            </div>

                            <div class="form-group col-sm-4">
                                <div class="pane">
                                    <div class="valor-container">
                                        <span class="text-muted text-bold">Total de numerações ausentes</span>
                                        <div>
                                            <span class="valor">{{$ctrl.countTotal}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group col-sm-4">
                                <div class="pane">
                                    <div class="valor-container">
                                        <span class="text-muted text-bold">Total de NF-e ausentes</span>
                                        <div>
                                            <span class="valor">{{$ctrl.countNfe}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group col-sm-4">
                                <div class="pane">
                                    <div class="valor-container">
                                        <span class="text-muted text-bold">Total de NFC-e ausentes</span>
                                        <div>
                                            <span class="valor">{{$ctrl.countNfce}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group col-sm-12" ng-if="$ctrl.countTotal" >
                                <div class="pane">
                                    <div class="valor-container">
                                        <span class="text-muted text-bold">Séries conhecidas</span>
                                        <div class="row">
                                            <div class="smart-form">
                                                <div class="form-group col-sm-3 col-lg-2" style="padding-left: 13px;">
                                                    <label>Modelo </label>
                                                    <div class="inline-group">
                                                        <label class="radio no-break">
                                                            <input type="radio" ng-model="$ctrl.filter.modelo" ng-click="$ctrl.serie = null" value="NFE">
                                                            <i></i> NF-e 
                                                        </label>
                                                        <label class="radio no-break">
                                                            <input type="radio" ng-model="$ctrl.filter.modelo" ng-click="$ctrl.serie = null" value="NFCE">
                                                            <i></i> NFC-e
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group col-sm-5 col-lg-5">
                                                <label style="color: #666;">
                                                    Período
                                                    <i class="fa fa-trash-o text-danger cursor-pointer" 
                                                    ng-click="$ctrl.filterPeriodo = undefined"
                                                    ng-if="$ctrl.filterPeriodo"></i>
                                                </label>
                                                <periodo-input 
                                                    name="emissao" 
                                                    ng-model="$ctrl.filterPeriodo.periodo">
                                                </periodo-input>
                                            </div>
                                            <div class="form-group col-sm-3">
                                                <label for="" class="hidden-xs">&nbsp;</label>
                                                <button type="button" class="btn btn-primary btn-block" ng-click="$ctrl.updateFilter()">
                                                    <i class="fa fa-refresh"></i> Atualizar
                                                </button>
                                            </div>
                                        </div>
                                        <table class="table no-margin" ng-if="$ctrl.countIntervalosNumeracaoAusentesOfModelo.length && $ctrl.filter.modelo">
                                            <thead>
                                                <tr>
                                                    <th>Série</th>
                                                    <th>Quantidade de numerações ausentes</th>
                                                    <th>Última numeração conhecida</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr ng-repeat="intervalo in $ctrl.countIntervalosNumeracaoAusentesOfModelo">
                                                    <td>
                                                        <a href="javascript:void(0)" ng-click="$ctrl.selectSerie(intervalo.serie)">{{intervalo.serie}}</a>
                                                    </td>
                                                    <td>{{intervalo.count}}</td>
                                                    <td>{{intervalo.ultimaNumeracao}}</td>
                                                <tr>
                                            </tbody>
                                        </table>
                                        <div ng-if="!$ctrl.filter.modelo">
                                            <highlighted class="message">
                                                <main>Selecione um dos modelos acima.</main>
                                            </highlighted>
                                        </div>
                                        <div ng-if="$ctrl.filter.modelo && !$ctrl.countIntervalosNumeracaoAusentesOfModelo.length">
                                            <highlighted class="message">
                                                <main>Nenhuma informação encontrada para o modelo {{$ctrl.filter.modelo == 'NFE' ? 'NF-e' : 'NFC-e'}}.</main>
                                            </highlighted>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group col-sm-12" ng-if="!$ctrl.countTotal">
                                <div class="pane">
                                    <div class="message" style="height: 100px;" >
                                        <span>Nenhuma informação encontrada.</span>
                                        <span>Importe um XML de nota fiscal ou inutilização para visualizar as sequências de numerações.</span>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group col-sm-12" ng-if="$ctrl.filter.modelo">
                                <div class="pane">
                                    <div class="pane-message" ng-if="!$ctrl.serie">
                                        <span>Clique em uma das séries acima para exibir o detalhamento.</span>
                                    </div>
                                    <loading promise="$ctrl.loadingPromise">
                                        <div class="valor-container" ng-if="$ctrl.serie && $ctrl.intervalosNumeracao.length">
                                            <span class="text-muted text-bold">
                                                Detalhamento da presença das numerações na série {{$ctrl.serie}} ({{$ctrl.filter.modelo == 'NFE' ? 'NF-e' : 'NFC-e'}})
                                            </span>
                                            <div style="margin: 10px 0px;">
                                                <span class="cursor-pointer" ng-class="{'detalhamento-titulo': $ctrl.onlyPresentes}" style="margin-right: 30px" ng-click="$ctrl.selectOnlyPresentes()">
                                                    <i class="fa fa-square numeracao-presente" aria-hidden="true"></i>
                                                    Presentes no EF 
                                                </span> 
                                                <span class="cursor-pointer" ng-class="{'detalhamento-titulo': $ctrl.onlyAusentes}" ng-click="$ctrl.selectOnlyAusentes()">
                                                    <i class="fa fa-square numeracao-ausente" aria-hidden="true"></i>
                                                    Ausentes no EF
                                                </span>
                                            </div>
                                            <div class="container-detalhamento">
                                                <span 
                                                    ng-repeat="intervalo in $ctrl.numeracoes track by $index" 
                                                    class="{{ intervalo.presente ? 'numeracao-presente' : 'numeracao-ausente'}} text-bold detalhamento">
                                                    <span ng-hide="intervalo.intervalo.from == intervalo.intervalo.to">
                                                        {{ intervalo.intervalo.from }} - {{ intervalo.intervalo.to }}
                                                    </span>
                                                    <span ng-show="intervalo.intervalo.from == intervalo.intervalo.to">
                                                        {{ intervalo.intervalo.from }} 
                                                    </span>
                                                    <span style="margin-right: 5px;">{{ $last ? '' : ', ' }}</span>
                                                </span>
                                            </div>
                                            <div ng-if="$ctrl.nextPage" style="text-align: center;">
                                                <a href="javascript:void(0)" class="btn btn-link" ng-click="$ctrl.loadMore({after: $ctrl.nextPage})">Ver Mais</a> 
                                            </div>
                                        </div>
                                        <div style="text-align: right;" ng-if="$ctrl.serie && $ctrl.intervalosNumeracao.length">
                                            <a 
                                                class="btn btn-link" 
                                                href="javascript:void(0)" 
                                                ng-click="$ctrl.downloadXlsx()" 
                                                style="padding-right: 0">
                                                Exportar numerações ausentes <i class="fa fa-download"></i>
                                            </a>
                                        </div>

                                        <div class="pane-message" ng-if="$ctrl.serie && !$ctrl.intervalosNumeracao.length ">
                                            <span>Nenhum detalhamento para o período informado.</span>
                                        </div>
                                    </loading>
                                </div>
                            </div>

                            <div>
                                <span class="text-muted" style="margin-left: 10px;">*Para confirmar a existência de uma nota fiscal, entre em contato com a SEFAZ de seu estado.</span>
                                <br>
                                <span class="text-muted" style="margin-left: 10px;">**O XML de inutilização de NF-e pode ser importado para reduzir a quantidade de numerações ausentes.</span>
                            </div>
                        </loading>
                </modal-body>
                <modal-footer>
                    <button class="btn btn-default" type="button" ng-click="$ctrl.close()">Fechar</button>
                </modal-footer>
            </modal>
        `
    })
